"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.awsParameterConfig = void 0;
const client_ssm_1 = require("@aws-sdk/client-ssm");
const assertions_1 = require("../assertions");
const ssmService_1 = require("../aws/ssmService");
const resolveConfigValue_1 = require("./resolveConfigValue");
/**
 * Returns a value from the AWS Parameter Store.
 *
 * @param parameterName the name of the parameter; can be a literal name (string) or can itself
 * be accessed via another parameter by giving a configuration value provider.
 * @example const someValue = resolveConfig(awsParameterConfig('some-parameter-name'));
 * @returns the configuration value provider for the value
 */
const awsParameterConfig = (parameterName) => {
    return async () => {
        const command = new client_ssm_1.GetParameterCommand({ Name: await (0, resolveConfigValue_1.resolveConfigValue)(parameterName), WithDecryption: true });
        // send() throws ParameterNotFound if the parameter is missing,
        // so it's not clear what missing Parameter or Value mean
        const response = await (0, ssmService_1.ssmService)().send(command);
        const parameter = (0, assertions_1.assertDefined)(response.Parameter, `aws GetParameter response missing Parameter key for ${parameterName}"`);
        return (0, assertions_1.assertDefined)(parameter.Value, `aws GetParameter response missing Parameter.Value key for ${parameterName}"`);
    };
};
exports.awsParameterConfig = awsParameterConfig;
